import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.array.concat.js';

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$7 = {
  name: 'VuePhotoZoomProMask',
  props: {
    zoomRegion: {
      type: Object,
      default: function _default() {
        return {
          width: 0,
          height: 0
        };
      }
    },
    selector: {
      type: Object,
      default: function _default() {
        return {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        };
      }
    },
    maskColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    topStyle: function topStyle() {
      var selector = this.selector,
          zoomRegion = this.zoomRegion;
      return {
        width: "".concat(zoomRegion.width, "px"),
        height: "".concat(selector.top, "px")
      };
    },
    leftStyle: function leftStyle() {
      var selector = this.selector;
      return {
        width: "".concat(selector.left, "px"),
        height: "".concat(selector.height, "px")
      };
    },
    rightStyle: function rightStyle() {
      var selector = this.selector,
          zoomRegion = this.zoomRegion;
      return {
        width: "".concat(zoomRegion.width - selector.left - selector.width, "px"),
        height: "".concat(selector.height, "px")
      };
    },
    bottomStyle: function bottomStyle() {
      var selector = this.selector,
          zoomRegion = this.zoomRegion;
      return {
        width: "".concat(zoomRegion.width, "px"),
        height: "".concat(zoomRegion.height - selector.top - selector.height, "px")
      };
    },
    maskStyle: function maskStyle() {
      return {
        backgroundColor: this.maskColor
      };
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "mask",
    style: _vm.maskStyle
  }, [_c('div', {
    staticClass: "block top",
    style: _vm.topStyle
  }), _vm._v(" "), _c('div', {
    staticClass: "block left",
    style: _vm.leftStyle
  }), _vm._v(" "), _c('div', {
    staticClass: "block right",
    style: _vm.rightStyle
  }), _vm._v(" "), _c('div', {
    staticClass: "block bottom",
    style: _vm.bottomStyle
  })]);
};

var __vue_staticRenderFns__$7 = [];
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = "data-v-421f99dc";
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$6 = {
  name: 'VuePhotoZoomProZoomer',
  props: {
    left: {
      type: Number,
      default: 0
    },
    top: {
      type: Number,
      default: 0
    },
    scale: {
      type: Number,
      default: 2
    },
    zoomRegion: {
      type: Object,
      default: function _default() {
        return {
          width: 0,
          height: 0
        };
      }
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  computed: {
    zoomerStyle: function zoomerStyle() {
      return {
        width: "".concat(this.width, "px"),
        height: "".concat(this.height, "px")
      };
    },
    positionStyle: function positionStyle() {
      return {
        transform: "translate3d(".concat(-this.left, "px, ").concat(-this.top, "px, 0)")
      };
    },
    zoomedStyle: function zoomedStyle() {
      var zoomRegion = this.zoomRegion;
      return {
        transform: "scale(".concat(this.scale, ") translateZ(0)"),
        width: "".concat(zoomRegion.width, "px"),
        height: "".concat(zoomRegion.height, "px")
      };
    }
  }
};

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "zoomer",
    style: _vm.zoomerStyle
  }, [_c('div', {
    staticClass: "position",
    style: _vm.positionStyle
  }, [_vm.$slots.default ? _c('div', {
    staticClass: "custom-zoomer",
    style: _vm.zoomedStyle
  }, [_vm._t("default")], 2) : _vm._e()])]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = "data-v-9dd5af42";
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$5 = {
  name: 'VuePhotoZommProSelector',
  props: {
    left: {
      type: Number,
      default: 0
    },
    top: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'square'
    }
  },
  computed: {
    selectorStyle: function selectorStyle() {
      return {
        width: "".concat(this.width, "px"),
        height: "".concat(this.height, "px"),
        transform: "translate3d(".concat(this.left, "px, ").concat(this.top, "px, 0)")
      };
    }
  }
};

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['selector', _vm.type],
    style: _vm.selectorStyle
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = "data-v-2bf22088";
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
var script$4 = {
  name: 'ImgPreview',
  props: {
    url: {
      type: String,
      default: ''
    }
  }
};

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('img', _vm._g(_vm._b({
    staticClass: "img-region",
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "src": _vm.url
    }
  }, 'img', _vm.$attrs, false), _vm.$listeners));
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
var script$3 = {
  name: 'ImgZoomer',
  props: {
    url: {
      type: String,
      default: ''
    }
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('img', _vm._g(_vm._b({
    staticClass: "img-zoomer",
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.url
    }
  }, 'img', _vm.$attrs, false), _vm.$listeners));
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

var getBoundingClientRect = function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect(); // whether the IE version is lower than 11

  var isIE = navigator.userAgent.indexOf('MSIE') !== -1; // fix ie document bounding top always 0 bug

  var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;
  return {
    left: rect.left,
    top: rectTop,
    right: rect.right,
    bottom: rect.bottom,
    width: rect.right - rect.left,
    height: rect.bottom - rectTop
  };
};
function clamp(num, min, max) {
  var MIN = min;
  var MAX = max;
  return Math.min(Math.max(num, MIN), MAX);
}
var getBoundValue = function getBoundValue(value, bound) {
  return {
    x: clamp(value.x, bound.left, bound.right),
    y: clamp(value.y, bound.top, bound.bottom)
  };
};
var generateBound = function generateBound(width, height, boundWidth, boundHeight) {
  return {
    left: boundWidth,
    top: boundHeight,
    right: width - boundWidth,
    bottom: height - boundHeight
  };
};
var getScrollInfo = function getScrollInfo() {
  var _document = document,
      documentElement = _document.documentElement,
      body = _document.body;
  var scrollTop = documentElement.scrollTop || window.pageYOffset || body.scrollTop;
  var scrollLeft = documentElement.scrollLeft || window.pageXOffset || body.scrollLeft;
  return {
    scrollTop: scrollTop,
    scrollLeft: scrollLeft
  };
};
/**
 * load img
 * @param {String} img url
 * @return {Promise}
 */

var loadImg = function loadImg(url, callback) {
  var img = document.createElement('img');
  img.addEventListener('load', function () {
    return callback(null, img);
  });
  img.addEventListener('error', callback);
  img.src = url;
};
function rotateCanvas(canvas, img, width, height, step) {
  var ctx = canvas.getContext('2d');
  var degree = step * 90 * Math.PI / 180;
  var imgWidth = img.width,
      imgHeight = img.height;

  switch (step) {
    case 0:
      canvas.width = imgWidth;
      canvas.height = imgHeight;
      ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      break;

    case 1:
      canvas.width = imgHeight;
      canvas.height = imgWidth;
      ctx.rotate(degree);
      ctx.drawImage(img, 0, -imgHeight, imgWidth, imgHeight);
      canvas.style.width = height + 'px';
      canvas.style.height = width + 'px';
      break;

    case 2:
      canvas.width = imgWidth;
      canvas.height = imgHeight;
      ctx.rotate(degree);
      ctx.drawImage(img, 0, 0, -imgWidth, -imgHeight);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      break;

    case 3:
      canvas.width = imgHeight;
      canvas.height = imgWidth;
      ctx.rotate(degree);
      ctx.drawImage(img, -imgWidth, 0, imgWidth, imgHeight);
      canvas.style.width = height + 'px';
      canvas.style.height = width + 'px';
      break;
  }
}

var script$2 = {
  name: 'CanvasPreview',
  props: {
    url: {
      type: String,
      default: ''
    },
    rotate: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  computed: {
    step: function step() {
      return parseInt(this.rotate % 360 / 90, 10);
    }
  },
  watch: {
    step: function step(newValue) {
      this.handleRotate(newValue);
    },
    url: {
      handler: function handler(url) {
        var _this = this;

        loadImg(url, function (err, img) {
          if (err) return console.error(err);
          _this.$img = img;

          _this.handleRotate(_this.step);
        });
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.$canvas = this.$refs.canvas;
  },
  methods: {
    handleRotate: function handleRotate(step) {
      rotateCanvas(this.$canvas, this.$img, this.width || this.$img.width, this.height || this.$img.height, step);
    }
  }
};

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('canvas', _vm._g(_vm._b({
    ref: "canvas",
    staticClass: "canvas-area"
  }, 'canvas', _vm.$attrs, false), _vm.$listeners));
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

var script$1 = {
  name: 'CanvasZoomer',
  props: {
    url: {
      type: String,
      default: ''
    },
    rotate: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  computed: {
    step: function step() {
      return parseInt(this.rotate % 360 / 90, 10);
    }
  },
  watch: {
    step: function step(newValue) {
      this.handleRotate(newValue);
    },
    url: {
      handler: function handler(url) {
        var _this = this;

        loadImg(url, function (err, img) {
          if (err) return console.error(err);
          _this.$img = img;

          _this.handleRotate(_this.step);
        });
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.$canvas = this.$refs.canvas;
  },
  methods: {
    handleRotate: function handleRotate(step) {
      rotateCanvas(this.$canvas, this.$img, this.width || this.$img.width, this.height || this.$img.height, step);
    }
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('canvas', _vm._g(_vm._b({
    ref: "canvas",
    staticClass: "canvas-zoomer"
  }, 'canvas', _vm.$attrs, false), _vm.$listeners));
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var script = {
  name: 'VuePhotoZoomPro',
  components: {
    PhotoMask: __vue_component__$7,
    Selector: __vue_component__$5,
    Zoomer: __vue_component__$6,
    ImgPreview: __vue_component__$4,
    ImgZoomer: __vue_component__$3
  },
  props: {
    width: {
      type: Number,
      default: 168
    },
    height: {
      type: Number,
      default: -1
    },
    url: {
      type: String,
      default: ''
    },
    highUrl: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'square',
      validator: function validator(value) {
        return ['circle', 'square'].indexOf(value) !== -1;
      }
    },
    scale: {
      type: Number,
      default: 2
    },
    enterEvent: {
      type: [Object, UIEvent],
      default: null
    },
    moveEvent: {
      type: [Object, UIEvent],
      default: null
    },
    leaveEvent: {
      type: [Object, UIEvent],
      default: null
    },
    selector: {
      type: [Boolean, Object],
      default: true
    },
    outZoomer: {
      type: [Boolean, Object],
      default: false
    },
    disabledReactive: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: false
    },
    maskColor: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      mouseEnter: false,
      outZoomerTop: 0,
      mouse: {
        x: 0,
        y: 0
      },
      zoomRegionRect: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      }
    };
  },
  computed: {
    selectorOptions: function selectorOptions() {
      return _typeof(this.selector) === 'object' ? this.selector : {
        release: false
      };
    },
    outZoomerOptions: function outZoomerOptions() {
      return _typeof(this.outZoomer) === 'object' ? this.outZoomer : {
        sticky: false
      };
    },
    selectorWidth: function selectorWidth() {
      return this.width;
    },
    selectorHeight: function selectorHeight() {
      return this.height > -1 ? this.height : this.width;
    },
    selectorHalfWidth: function selectorHalfWidth() {
      return this.selectorWidth / 2;
    },
    selectorHalfHeight: function selectorHalfHeight() {
      return this.selectorHeight / 2;
    },
    zoomerWidth: function zoomerWidth() {
      return this.outZoomer ? this.selectorWidth * this.scale : this.selectorWidth;
    },
    zoomerHeight: function zoomerHeight() {
      return this.outZoomer ? this.selectorHeight * this.scale : this.selectorHeight;
    },
    zoomerHalfWidth: function zoomerHalfWidth() {
      return this.zoomerWidth / 2;
    },
    zoomerHalfHeight: function zoomerHalfHeight() {
      return this.zoomerHeight / 2;
    },
    zoomRegionAbsolute: function zoomRegionAbsolute() {
      var zoomRegionRect = this.zoomRegionRect;

      var _getScrollInfo = getScrollInfo(),
          scrollTop = _getScrollInfo.scrollTop,
          scrollLeft = _getScrollInfo.scrollLeft;

      return {
        left: zoomRegionRect.left + scrollLeft,
        top: zoomRegionRect.top + scrollTop
      };
    },
    pointBound: function pointBound() {
      var zoomRegionRect = this.zoomRegionRect;
      return generateBound(zoomRegionRect.width, zoomRegionRect.height, this.selectorHalfWidth, this.selectorHalfHeight);
    },
    vPointBound: function vPointBound() {
      var zoomRegionRect = this.zoomRegionRect,
          scale = this.scale;
      return generateBound(zoomRegionRect.width * scale, zoomRegionRect.height * scale, this.zoomerHalfWidth, this.zoomerHalfHeight);
    },
    point: function point() {
      var mouse = this.mouse,
          selectorOptions = this.selectorOptions;
      return !selectorOptions.release ? getBoundValue(mouse, this.pointBound) : mouse;
    },
    vPoint: function vPoint() {
      var mouse = this.mouse,
          scale = this.scale,
          selectorOptions = this.selectorOptions;
      var scaleMouse = {
        x: mouse.x * scale,
        y: mouse.y * scale
      };
      return !selectorOptions.release ? getBoundValue(scaleMouse, this.vPointBound) : scaleMouse;
    },
    selectorProps: function selectorProps() {
      var point = this.point;
      return {
        width: this.selectorWidth,
        height: this.selectorHeight,
        left: point.x - this.selectorHalfWidth,
        top: point.y - this.selectorHalfHeight
      };
    },
    zoomerProps: function zoomerProps() {
      var vPoint = this.vPoint;
      return {
        scale: this.scale,
        zoomRegion: this.zoomRegionRect,
        width: this.zoomerWidth,
        height: this.zoomerHeight,
        left: vPoint.x - this.zoomerHalfWidth,
        top: vPoint.y - this.zoomerHalfHeight
      };
    },
    outZoomerPosition: function outZoomerPosition() {
      return {
        top: "".concat(this.outZoomerTop, "px")
      };
    }
  },
  watch: {
    scale: function scale() {
      this.handleMouseMove(this.pointerInfo);
    },
    enterEvent: function enterEvent(v) {
      !this.disabled && this.handleMouseEnter(v);
    },
    moveEvent: function moveEvent(v) {
      !this.disabled && this.handleMouseMove(v);
    },
    leaveEvent: function leaveEvent(v) {
      !this.disabled && this.handleMouseLeave(v);
    }
  },
  mounted: function mounted() {
    this.$zoomRegion = this.$refs.zoomRegion;
    this.update();
    this.$emit('created');
  },
  methods: {
    handleMouseEnter: function handleMouseEnter(e) {
      !this.disabledReactive && this.update();
      this.mouseEnter = true;
      this.$emit('mouseenter', e);
    },
    handleMouseMove: function handleMouseMove(e) {
      !this.disabledReactive && this.update();
      e = this.pointerInfo = e || this.pointerInfo;
      var _e = e,
          pageX = _e.pageX,
          pageY = _e.pageY;
      var mouse = this.mouse,
          zoomRegionAbsolute = this.zoomRegionAbsolute;
      mouse.x = pageX - zoomRegionAbsolute.left;
      mouse.y = pageY - zoomRegionAbsolute.top;

      if (this.outZoomer && this.outZoomerOptions.sticky) {
        this.outZoomerTop = Math.max(pageY - e.clientY, 0);
      }

      this.$emit('mousemove', e);
    },
    handleMouseLeave: function handleMouseLeave(e) {
      this.mouseEnter = false;
      this.$emit('mouseleave', e);
    },
    update: function update() {
      Object.assign(this.zoomRegionRect, getBoundingClientRect(this.$zoomRegion));
    }
  }
};

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vue-photo-zoom-pro"
  }, [_c('div', {
    ref: "zoomRegion",
    staticClass: "zoom-region",
    on: {
      "mouseenter": function mouseenter($event) {
        !_vm.disabled && !_vm.enterEvent && _vm.handleMouseEnter($event);
      },
      "mousemove": function mousemove($event) {
        !_vm.disabled && !_vm.moveEvent && _vm.handleMouseMove($event);
      },
      "mouseleave": function mouseleave($event) {
        !_vm.disabled && !_vm.leaveEvent && _vm.handleMouseLeave($event);
      }
    }
  }, [_vm.mask ? _c('PhotoMask', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mouseEnter,
      expression: "mouseEnter"
    }],
    attrs: {
      "mask-color": _vm.maskColor,
      "selector": _vm.selectorProps,
      "zoom-region": _vm.zoomRegionRect
    }
  }) : _vm._e(), _vm._v(" "), _vm.selector ? _c('Selector', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mouseEnter,
      expression: "mouseEnter"
    }],
    attrs: {
      "type": _vm.type
    }
  }, 'Selector', _vm.selectorProps, false), [!_vm.outZoomer ? _c('Zoomer', _vm._b({
    staticClass: "inner-zoomer"
  }, 'Zoomer', _vm.zoomerProps, false), [_vm.highUrl || _vm.url ? _c('ImgZoomer', {
    attrs: {
      "url": _vm.highUrl || _vm.url
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("zoomer")], 2) : _vm._e(), _vm._v(" "), _vm._t("selector")], 2) : _vm._e(), _vm._v(" "), _vm.outZoomer ? _c('Zoomer', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mouseEnter,
      expression: "mouseEnter"
    }],
    staticClass: "out-zoomer",
    style: _vm.outZoomerPosition
  }, 'Zoomer', _vm.zoomerProps, false), [_vm.highUrl || _vm.url ? _c('ImgZoomer', {
    attrs: {
      "url": _vm.highUrl || _vm.url
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("zoomer")], 2) : _vm._e(), _vm._v(" "), _vm.url ? _c('ImgPreview', {
    attrs: {
      "url": _vm.url
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = "data-v-7f4719a4";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export { __vue_component__$2 as CanvasPreview, __vue_component__$1 as CanvasZoomer, __vue_component__$4 as ImgPreview, __vue_component__$3 as ImgZoomer, __vue_component__ as default };
